// extracted by mini-css-extract-plugin
export default {"CollapseStyle":"RightInfo_CollapseStyle__lUXRf","RightInfoStyle":"RightInfo_RightInfoStyle__xNbgj"};